// extracted by mini-css-extract-plugin
module.exports = {"active":"sidebar-module--active--14qFW","inactive":"sidebar-module--inactive--2eeLT","sidebar":"sidebar-module--sidebar--2ZGHi"};